import { getData, postData } from "./api";

export const Per_Page_Dropdown = async (data) => {
  const a = [];
  for (let i = 5; i <= data; i *= 2) {
    a.push(i);
  }
  a.push(data);

  return a;
};

export function formatDate(dateString) {
  const date = new Date(dateString);

  const options = {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  };

  // Get formatted date string in the form "Sep 2, 2024, 7:39 AM"
  const formattedDate = date.toLocaleString("en-US", options);

  // Split the formatted date into its parts
  const [month, day, year] = formattedDate.match(/(\w+) (\d+), (\d+)/).slice(1);
  const time = formattedDate.match(/(\d+:\d+\s[APM]+)/)[0];

  // Rearrange to "6 Aug 2024, 7:39 AM"
  return `${day} ${month} ${year}, ${time}`;
}
export const IDS = {
  Role: { List: 1, Add: 2, Edit: 3, Delete: 4 },
  Dashboard: {
    TotalRegistration: 5,
    ReferralActivity: 6,
    TotalFunds: 7,
    Withdrawal: 8,
    Graph: 9,
  },
  AppSetup: { List: 10, Edit: 11, StatusChange: 12 },
  Calendar: { List: 13 },
  PnlClient: { List: 14, Add: 15, Download: 16 },
  PnlTransaction: { List: 17, Add: 18, Download: 19 },
  FAQ: { List: 20, Add: 21, Edit: 22, Delete: 23 },
  Investor: {
    List: 24,
    BankAccountDetails: 25,
    KYCDetails: 26,
    AddAmount: 27,
    Download: 28,
    Edit: 60,
  },
  InvestorLedger: { List: 29, Download: 30 },
  Reports: { List: 29, Download: 30 },
  AppOperations: { List: 31, Add: 32, Download: 33, Delete: 34 },
  InwardPayment: {
    InvestorList: 35,
    ReportList: 36,
    Add: 37,
    Delete: 38,
    Download: 39,
  },
  OutwardPayment: {
    UsersList: 40,
    ReportList: 41,
    UsersDownload: 42,
    ReportDownload: 43,
    Submit: 44,
    Edit: 45,
  },
  TransferPayment: { List: 46, Download: 47 },
  Notification: { List: 48, Add: 49, Download: 50 },
  PNLClientTransaction: { List: 51, Download: 52 },
  Employee: { List: 53, Add: 54, Edit: 55, Delete: 56 },
  RateUs: { List: 57, Download: 58 },
  Chats: { List: 61 },

  MTInwardPayment: {
    UsersList: 62,
    ReportList: 63,
    UsersDownload: 64,
    ReportDownload: 65,
    Submit: 66,
    Edit: 67,
  },

  MTOutwardPayment: {
    UsersList: 68,
    ReportList: 69,
    UsersDownload: 70,
    ReportDownload: 71,
    Submit: 72,
    Edit: 73,
  },

  MTTransferPayment: { List: 74, Download: 75 },

  MTBulkAddUsers: { List: 76 },
  MTTransferPaymentToMain: {
    UsersList: 77,
    ReportList: 78,
    UsersDownload: 79,
    ReportDownload: 80,
    Submit: 81,
  },

  MTInvestorLedger: {
    List: 82,
  },
};

// export function formatDate(dateString) {
//   const date = new Date(dateString);
//   return `${date?.toISOString()?.split("T")?.[0]}  ${date?.toTimeString()?.split(" ")[0]}`;
// }
export function formatDateTime(dateString) {
  const date = new Date(dateString);

  // Extract individual components
  const year = date.getUTCFullYear();
  const month = date.getUTCMonth() + 1; // getUTCMonth returns month from 0-11
  const day = date.getUTCDate();
  let hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  const seconds = date.getUTCSeconds();

  // Determine AM/PM
  const ampm = hours >= 12 ? "PM" : "AM";

  // Convert hours from 24-hour to 12-hour format
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'

  // Add leading zeros if needed
  const formattedDay = day < 10 ? `0${day}` : day;
  const formattedMonth = month < 10 ? `0${month}` : month;
  const formattedHours = hours < 10 ? `0${hours}` : hours;
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
  const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;

  // Format components as needed
  const formattedDate = `${formattedDay}/${formattedMonth}/${year} ${formattedHours}:${formattedMinutes}:${formattedSeconds} ${ampm}`;

  return formattedDate;
}

export function getPaginationMessage(TotalEntries, per_page, currentPage) {
  // Calculate the starting and ending entries for the current page
  let startEntry = (currentPage - 1) * per_page + 1;
  let endEntry = currentPage * per_page;

  // Ensure the end entry does not exceed the Total number of entries
  if (endEntry > TotalEntries) {
    endEntry = TotalEntries;
  }

  return `Showing ${startEntry} to ${endEntry} of ${TotalEntries} entries`;
}

export const Select2Data = async (data, name, other = false) => {
  const result = data.map((data) => ({
    value: data?.id,
    label: data?.name,
    name: name,
  }));

  if (other) {
    result.push({ value: "0", label: "Other", name: name });
  }
  return result;
};

export const Select2BankData = async (data, name, other = false) => {
  const result = data?.map((data) => ({
    value: data?.id,
    label: data?.upi_id || data?.bank_name + " (" + data?.firm_name + ")",
    name: name,
  }));

  if (other) {
    result.push({ value: "0", label: "Other", name: name });
  }
  return result;
};

export const RegxExpression = {
  name: /[A-Z-a-z ]/,
  email:
    /^([A-Za-z0-9_\-\.])+\@(?!(?:[A-Za-z0-9_\-\.]+\.)?([A-Za-z0-9_\-\.]+)\.\2)([A-Za-z0-9_\-\.]+\.)+([A-Za-z]{2,4})$/,
  phone: /[0-9]/,

  ifsc: "^[A-Z]{4}[0][dA-Z]{6}$",
  ifsc_code: /^[A-Z0-9]$/,
  micr: /^[0-9]{9}$/,
  bank_number: /^\d{0,14}$/,
  gst: /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[1-9A-Z]{1}$/,
};

export const Convertamount = async (amount) => {
  const response = await postData(`/exchange-rate-calculation`, {
    amount: amount,
    type: "USD_TO_INR",
  });
  return response;
};
